// extracted by mini-css-extract-plugin
export default {"lobby":"lobby_lobby__71xXp","roomItem":"lobby_roomItem__wX+eq","roomItem__data":"lobby_roomItem__data__TATDv","roomItem__games":"lobby_roomItem__games__Czx5J"};